import { apiGet } from '../../API/httpCommon';
import { useEffect, useState } from 'react';
import { ProductModel } from '../../Model/ProductModel';
import config from '../../config.json';
import { debug } from 'console';
import { useParams } from 'react-router-dom';
import Spinner from '../Spinner/Spinner';
import { AddUpdateCart, GetCart } from '../../Utility/CartUtility';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { OrderOutsideIndiaUtilityAddUpdate, GetOrderOutsideIndia, RemoveAllOrderOutsideIndia } from '../../Utility/OrderOutsideIndiaUtility'

const ProductDetails = (props: any) => {
    const { bookNameitemId } = useParams();
    const [ItemId, setItemId] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [Quantity, setQuantity] = useState(1);
    const [LargeImage, setLargeImage] = useState('');

    const [productDetail, setproductDetail] = useState<any>(null);
    const navigate = useNavigate();

    const [metaTitle,setMetaTitle] = useState('');
    const [metaDesc,setMetaDesc] = useState('');

    const [multipleItemSame, setMultipleItemSame]  = useState<any>(null);

    useEffect(() => {


        let _bookNameitemId: any = bookNameitemId?.split('-');
        let _itemId = _bookNameitemId[_bookNameitemId?.length - 1];
        setItemId(_itemId);

        GetProductDetails(_itemId);

    }, []);


    const GetProductDetails = (pid: any) => {

        setIsLoading(true);
        apiGet("api/ProductDetails/GetProductDetails?pid=" + pid).then((res: any) => {
            
            
            setproductDetail(res?.Data);
            setLargeImage(config?.FullImageImageBaseUrl + res?.Data?.Image_Link);
            setIsLoading(false);
            SetMetaDetails(res?.Data);

            GetMultipleItemSame(res?.Data?.Item_Title);

        });
    }


    const GetMultipleItemSame = (Item_Title: any) => {

        setIsLoading(true);
        apiGet("api/ProductDetails/GetMultipleItemSame?Item_Title=" + Item_Title).then((res: any) => {
            
            setMultipleItemSame(res?.Data);
            setIsLoading(false);
        });
    }



    const SetMetaDetails = (_productDetail: any) => {
        
        if (_productDetail?.Product_Name === 'Books') {
            if (_productDetail?.Meta_Title) {
                //document.title = _productDetail?.Meta_Title;
                setMetaTitle(_productDetail?.Meta_Title);
            }
            else {

                let publisher: any = _productDetail?.SpecificationList.filter((x: any) => x?.Specification_Name === "Publisher")[0]?.Specification_Value;
                //document.title = _productDetail?.Item_Title + ", " + _productDetail?.Category_Name + ", " + publisher;
                setMetaTitle(_productDetail?.Item_Title + ", " + _productDetail?.Category_Name + ", " + publisher);
            }

            if(_productDetail?.Meta_Description){
                setMetaDesc(_productDetail?.Meta_Description);
            }
            else{
                
                let Author: any = _productDetail?.SpecificationList.filter((x: any) => x?.Specification_Name === "Author(s)")[0]?.Specification_Value;
                let publisher: any = _productDetail?.SpecificationList.filter((x: any) => x?.Specification_Name === "Publisher")[0]?.Specification_Value;
                let ISBN: any = _productDetail?.SpecificationList.filter((x: any) => x?.Specification_Name === "ISBN")[0]?.Specification_Value;

                setMetaDesc(_productDetail?.Item_Title +"-"+_productDetail?.Item_Id+", "+Author + " Books, "+publisher+" Books,"+ISBN+" at Meripustak.");
            }


        }

    }


    const ProductQuantity = (Action: any) => {

        if (Action === '+') {
            setQuantity(Quantity + 1);
        }
        else if (Action === '-') {
            if (Quantity != 1) {
                setQuantity(Quantity - 1);
            }
        }


    }

    const addToCart = (actionType: any, _Item_Id: any, _Item_Title: any, _Quantity: any, _Seller_Price: any, _Seller_Id: any, _Item_Title_Url: any) => {

        const response = AddUpdateCart(actionType, _Item_Id, _Item_Title, _Quantity, _Seller_Price, _Seller_Id, 0, _Item_Title_Url);
        $("#CartText").text(GetCart().length);

    }


  

    const handleImage = (image: any) => {
        setLargeImage(config?.FullImageImageBaseUrl + image);
    }

    const handleOrdersOutsideIndia = (_productDetail : any) =>{
        
        const response = OrderOutsideIndiaUtilityAddUpdate(productDetail , 'Add',null,1);
        navigate('/OrderOutsideIndia');
    }


    return (
        <>
            {(isLoading && <Spinner></Spinner>)}

            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDesc} />
                {/* <meta name="keywords" content="react, helmet, seo, example" /> */}
            </Helmet>

            <div className=" breadcrumb-padding-180"></div>
            {/* <!-- Shop Details Section Start --> */}
            <section className="shop-details-section fix section-padding">
                <div className="container">
                    <div className="shop-details-wrapper">
                        <div className="row g-4">
                            <div className="col-lg-4">
                                <div className="shop-details-image">
                                    <div className="tab-content">
                                        <div id="thumb1" className="tab-pane fade show active">
                                            <div className="shop-details-thumb">
                                             {LargeImage && (<img src={LargeImage} alt="img" />)}
                                            </div>
                                        </div>
                                    </div>

                                    <span className="team-section">
                                        <div className="array-button">
                                            <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                                            <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                                        </div>
                                        <ul className="nav swiper team-slider">
                                            <div className="swiper-wrapper">
                                                {productDetail?.Product_Image_AllModelList?.map((item: any) => (
                                                    <li className="nav-item swiper-slide">
                                                        <a href="#thumb1" onClick={() => { handleImage(item?.Image_Link) }} data-bs-toggle="tab" className="nav-link active">
                                                            <img src={config?.FullImageImageBaseUrl + item?.Image_Link} alt="img" />
                                                        </a>
                                                    </li>
                                                ))}
                                            </div>
                                        </ul>

                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="shop-details-content">
                                    <div className="title-wrapper">
                                        {/* <h2>Enterprise Applications with C# and .NET Paperback – 30 April 2023</h2> */}
                                        <h2>{productDetail?.Item_Title}</h2>

                                        <div className="row">
                                            <div className="col-md-7">
                                                {/* <h4><b>Author :</b> A F Malavasi Cardoso</h4>
									<h4><b>Publisher :</b> BPB Publications</h4>
									<h4><b>Availabilty :</b> <span className="stock">In stock</span></h4> */}

                                                {/* <div className="star"><h4><b>Rating :</b>
                                                    <a> <i className={(productDetail?.Rating > 0 ? "fas fa-star" : "fa-regular fa-star")}></i></a>
                                                    <a><i className={(productDetail?.Rating > 1 ? "fas fa-star" : "fa-regular fa-star")}></i></a>
                                                    <a> <i className={(productDetail?.Rating > 2 ? "fas fa-star" : "fa-regular fa-star")}></i></a>
                                                    <a><i className={(productDetail?.Rating > 3 ? "fas fa-star" : "fa-regular fa-star")}></i></a>
                                                    <a><i className={(productDetail?.Rating > 4 ? "fas fa-star" : "fa-regular fa-star")}></i></a>
                                                </h4>
                                                </div> */}
                                                <div className="price-list">
                                                    <h4><b>price :</b> <span className="stock">₹ {productDetail?.Seller_Price}</span> &nbsp;&nbsp;&nbsp;  <del><span className="stock" style={{ color: "grey" }}>₹ {productDetail?.Base_Price}</span></del> [{productDetail?.Discount} % off ] </h4>
                                                </div>
                                                <div className="cart-wrapper">
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className="quantity-basket">
                                                                <h4 className="d-flex gap-3"><b className="qtyp">Quantity </b> <span className="qty">
                                                                    <button aria-hidden="true" onClick={() => ProductQuantity('-')}>−</button>
                                                                    <input type="number" name="qty" id="qty2" min="1" max="10" step="1" value={Quantity} />
                                                                    <button aria-hidden="true" onClick={() => ProductQuantity('+')}>+</button></span></h4>

                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            {
                                                                (productDetail?.Stock_Status === "PreOrder" || productDetail?.Stock_Status === "In Stock" ||
                                                                    productDetail?.Stock_Status === "In Stock" || productDetail?.Stock_Status === "Avaliable") && (
                                                                    <>
                                                                        <br />
                                                                        <a className="theme-btn btngrn" onClick={() => { addToCart('Add', productDetail?.Item_Id, productDetail?.Item_Title, Quantity, productDetail?.Seller_Price, productDetail.Seller_Id, productDetail.Item_Title_Url); navigate('/Cart'); }}>Buy Now</a>
                                                                        <br />
                                                                        <a className="theme-btn btnpnk" onClick={() => { addToCart('Add', productDetail?.Item_Id, productDetail?.Item_Title, Quantity, productDetail?.Seller_Price, productDetail.Seller_Id, productDetail.Item_Title_Url); navigate('/Cart'); }}> Add To Cart</a>

                                                                    </>)
                                                            }

                                                            {
                                                                (productDetail?.Stock_Status === "Permanently Discountinued" || productDetail?.Stock_Status === "Termprory Unavailable" ||
                                                                    productDetail?.Stock_Status === "Out of Stock") && (
                                                                    <><br></br><br></br><br></br>
                                                                        <span>{productDetail?.Stock_Status}</span>
                                                                    </>)
                                                            }
                                                        </div>
                                                    </div>

                                                </div>

                                                    {
                                                        (multipleItemSame != null && multipleItemSame && multipleItemSame?.length > 0 && ( <> 
                                                <div className="wid-title mt-10">
                                                    <h6>Weight</h6>
                                                </div>
                                                <ul className="nav nav-pills mb-3 mt-10" id="pills-tab" role="tablist">
                                                    {multipleItemSame.map((item : any )=> (
                                                    <li className="nav-item" role="presentation">
                                                        <button onClick={() => GetProductDetails(item?.Item_Id)} className={(ItemId == item?.Item_Id ? 'nav-link active wg' : 'nav-link wg')}  id={`pills-${item?.Item_Id}-tab`} data-bs-toggle="pill"
                                                            data-bs-target={`#pills-${item?.Item_Id}`} type="button" role="tab"
                                                            aria-controls={`pills-${item?.Item_Id}`} aria-selected="true">{item?.Specification_Value}</button>
                                                    </li>
                                              ))}
                                                </ul>

                                                </>))
                                                    }

                                            </div>
                                            <div className="col-md-5">
                                                {productDetail?.Product_Name === 'Books' &&
                                                    <div className="outside-order-area">
                                                        <div className="center">
                                                            <h3>Orders Outside India</h3>
                                                             <center> <br /><a onClick={() => {handleOrdersOutsideIndia(productDetail)}} className="theme-btn btnblu">Add to Cart</a></center><br /> 
                                                            <div className="checkout-item  align-items-center justify-content-between">
                                                                <p>Outside India Order Estimated<br />Delivery Time<br />7-10 Business Days</p>
                                                                <p>We Deliver Across 100+ Countries</p>
                                                                <p>MeriPustak’s Books are 100% New & Original</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="single-tab section-padding pb-0">
                            <h4>General Information : </h4><br />
                            <table className="table">
                                <tbody>
                                    {productDetail?.SpecificationList?.map((item: any) => (
                                        item?.Specification_Value && <tr><th scope="row">{item?.Specification_Name} </th><td>{item?.Specification_Value}</td></tr>
                                    ))}
                                </tbody>
                            </table><br />

                            <h4>Description : </h4><br />
                            <div className="description-items">
                                <p dangerouslySetInnerHTML={{ __html: productDetail?.Descriptions }}></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* <!-- Testimonial Section Start --> */}

            {/* <!-- Shop Section start  --> */}
            {/* <section className="shop-section section-padding fix pt-0 book-catagories-section">
        <div className="container">
            <div className="section-title-area">
                <div className="section-title">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">Related Products</h2>
                </div>

            </div>
			<div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
                </div>
           <div className="swiper book-slider">
                <div className="swiper-wrapper">
                   <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					
                    
                    
                    
                </div>
            </div>
        </div>
    </section> */}

            {/* <!-- Shop Section start  --> */}

            {/* <section className="shop-section section-padding fix">
        <div className="container">
              <div className="section-title-area">
                <div className="section-title">
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">Explore Catagories</h2>
                </div>
            </div>
				<div className="row">
					<div className="col-md-3">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{backgroundColor:"#adddb9"}}>
								<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
								<h2 className="wow fadeInUp" data-wow-delay=".2s">
									TAXATION<br/>
									BOOKS
								</h2>
								 <img src="/assets/img/taxataion.webp" alt="shape-img" style={{width: "90px",marginBottom:"10px"}}/><br/>
								<a href="#" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{backgroundColor:"#5e17eb", color:"#ffffff"}}>View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
								
							</div>
						</div>
					</div>
					<div className="col-md-6">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{backgroundColor:"#f7a072"}}>
								<div className="row">
									<div className="col-md-8">
										<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
										<h2 className="wow fadeInUp" data-wow-delay=".2s">
											LEGAL
											BOOKS
										</h2>
									</div>
									<div className="col-md-4">
										<a href="#" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
									</div>
								</div>
							</div>
						</div>
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#ffa857"}}>
								<div className="row">
									<div className="col-md-4">
										<a href="#" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s">View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
									</div>
									<div className="col-md-8">
										<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
										<h2 className="wow fadeInUp" data-wow-delay=".2s">
											SCIENCE
											BOOKS
										</h2>
									</div>
									
								</div>
							
								
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="book-shop-wrapper">
							<div className="cta-shop-box text-center" style={{background:"#d7eaf8"}}>
								<h6 className="wow fadeInUp" data-wow-delay=".4s"><i>START EXPLORING</i></h6>
								<h2 className="wow fadeInUp" data-wow-delay=".2s">
									MEDICAL<br/>
									BOOKS
								</h2>
								 <img src="/assets/img/medical.webp" alt="shape-img" style={{width: "100px", marginBottom:"10px"}}/><br/>
								<a href="#" className="theme-btn white-bg wow fadeInUp" data-wow-delay=".6s" style={{background:"#5e17eb", color:"#ffffff"}}>View More <i
										className="fa-solid fa-arrow-right-long"></i></a>
								
							</div>
						</div>
					</div>
				</div>
                

                
            
        </div>
    </section> */}

            {/* <!-- Shop Section start  --> */}
            {/* <section className="shop-section section-padding fix  book-catagories-section">
        <div className="container">
            <div className="section-title-area">
               <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist" style={{margin:"0 auto"}}>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-Engineering-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Engineering" type="button" role="tab"
                                                aria-controls="pills-Engineering" aria-selected="true">Engineering</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-Math-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Math" type="button" role="tab"
                                                aria-controls="pills-Math" aria-selected="false">Math & Stat</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link active" id="pills-Management-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Management" type="button" role="tab"
                                                aria-controls="pills-Management" aria-selected="false">Management</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-UPSC-tab"
                                                data-bs-toggle="pill" data-bs-target="#pills-UPSC"
                                                type="button" role="tab" aria-controls="pills-UPSC"
                                                aria-selected="false">UPSC </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-Nursing-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Nursing" type="button" role="tab"
                                                aria-controls="pills-Nursing" aria-selected="false">Nursing</button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-Kids-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Kids" type="button" role="tab"
                                                aria-controls="pills-Kids" aria-selected="false">Kids</button>
                                        </li>
										 <li className="nav-item" role="presentation">
                                            <button className="nav-link" id="pills-Travel-tab" data-bs-toggle="pill"
                                                data-bs-target="#pills-Travel" type="button" role="tab"
                                                aria-controls="pills-Travel" aria-selected="false">Travel</button>
                                        </li>
            </ul>
            </div>
			<div className="array-button">
                    <button className="array-prev"><i className="fal fa-arrow-left"></i></button>
                    <button className="array-next"><i className="fal fa-arrow-right"></i></button>
             </div>
				
			<div className="tab-content" id="pills-tabContent">
				<div className="tab-pane fade show" id="pills-Engineering" role="tabpanel" aria-labelledby="pills-Engineering-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="book-detail.html"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="book-detail.html">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
				<div className="tab-pane fade show" id="pills-Math" role="tabpanel" aria-labelledby="pills-Math-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                   <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                   
					
                </div>
            </div>
				</div>
				<div className="tab-pane fade show active" id="pills-Management" role="tabpanel" aria-labelledby="pills-Management-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
				<div className="tab-pane fade show" id="pills-UPSC" role="tabpanel" aria-labelledby="pills-UPSC-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
				<div className="tab-pane fade show" id="pills-Nursing" role="tabpanel" aria-labelledby="pills-Nursing-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
				<div className="tab-pane fade show" id="pills-Kids" role="tabpanel" aria-labelledby="pills-Kids-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
				<div className="tab-pane fade show" id="pills-Travel" role="tabpanel" aria-labelledby="pills-Travel-tab" tabIndex={0}>
				<div className="swiper book-slider ">
                <div className="swiper-wrapper">
                    <div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
					<div className="swiper-slide">
                        <div className="shop-box-items style-2">
                            <div className="book-thumb center">
                                <a href="#"><img src="/assets/img/book/01.png" alt="img"/></a>
                               
                                <ul className="shop-icon d-grid justify-content-center align-items-center">
                                    <li>
                                        <a href="#"><i className="far fa-heart"></i></a>
                                    </li>
                                 
                                </ul>
                            </div>
                            <div className="shop-content">
                                <h3><a href="#">Simple Things You To <br/> Save BOOK</a></h3>
								<h5> Publish Year:2023 </h5>
                                <ul className="price-list">
                                    <li>Price: ₹2000.00</li>
                                    <li>
                                        <del>₹3000.99</del>
                                    </li>
                                </ul>
                                
                            </div>
                            <div className="shop-button">
                                 <a href="cart.html" className="theme-btn crtbtn"><i className="fa-solid fa-basket-shopping"></i> Add To Cart</a>
                                <a href="book-detail.html" className="theme-btn crtbtn"><i className="fa-solid fa-list"></i> Buy Now</a>
                            </div>
                        </div>
                    </div>
                    
                    
                    
                </div>
            </div>
				</div>
			</div>
            
        </div>
    </section> */}


        </>);

};

export default ProductDetails;